import React from "react";
import Col from "react-bootstrap/Col";
import TopArrow from "../../../../../../images/icons/top-small-arrow.svg";
import DownArrow from "../../../../../../images/icons/bottom-small-arrow.svg";

/**
 * Project Dropdown Component
 * Reusable component for project/client/sprint selection dropdown
 */
const ProjectDropdown = ({
  isOpen,
  onToggle,
  filter,
  onFilterChange,
  filteredClientData,
  selectedClients,
  onClientToggle,
  selectedProject,
  onProjectSelect,
  onProjectToggle,
  onSprintSelect,
  projectNameEdit,
  sprintNameEdit,
  clientEdit,
  projectIdEdit,
  currentTextCount,
  isMobile = false,
  contentRef,
}) => {
  return (
    <>
      <Col className={isMobile ? "cursor" : "cursor 111"} onClick={onToggle}>
        <span
          className={`tooltip-tracker ${currentTextCount(
            projectNameEdit,
            sprintNameEdit && sprintNameEdit,
            clientEdit && clientEdit
          ) < 21 ? "small" : "large"}`}
        >
          {projectNameEdit} {`${sprintNameEdit ? ` - ${sprintNameEdit}` : ""}`}
          <input type="hidden" name="project" value={projectIdEdit} />
          <div className="project-name-tracker">{clientEdit}</div>
        </span>
        <span
          className={`${isMobile ? "project-name-edit-inner" : "project-tracker-inner"} ${currentTextCount(
            projectNameEdit,
            sprintNameEdit && sprintNameEdit,
            clientEdit && clientEdit
          ) < 21 ? "small" : "large"}`}
          style={{
            display: "inline-block",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            height: "22px",
            ...(isMobile && { maxWidth: "140px" }),
          }}
        >
          {projectNameEdit}
          {`${sprintNameEdit ? ` - ${sprintNameEdit}` : ""}`}
          <input type="hidden" name="project" value={projectIdEdit} />
          <div className="project-name-tracker">{clientEdit}</div>
        </span>
      </Col>
      {isOpen && (
        <div 
          className="custom-dropdown" 
          ref={contentRef} 
          onClick={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
        >
          <input
            type="text"
            className="search-bar"
            placeholder="Find Project or Client"
            value={filter}
            onChange={(e) => {
              e.stopPropagation();
              const filterValue = e.target.value;
              onFilterChange(filterValue);
              if (filterValue === "") {
                onClientToggle(new Set());
              } else {
                const matchingClients = filteredClientData.filter((client) =>
                  client.projects.some((project) =>
                    project.project_name.toLowerCase().includes(filterValue.toLowerCase())
                  )
                );
                onClientToggle(new Set(matchingClients));
              }
            }}
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            autoComplete="off"
          />
          <ul className="client-list" onMouseDown={(e) => e.stopPropagation()}>
            {filteredClientData.map((client) => (
              <div key={client._id} className="main-outer-item-dd" onMouseDown={(e) => e.stopPropagation()}>
                <div
                  className={`client-name1 ${selectedClients.has(client) ? "selected" : ""}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (client.projects.length > 0) {
                      const newSelectedClients = new Set(selectedClients);
                      if (selectedClients.has(client)) {
                        newSelectedClients.delete(client);
                      } else {
                        newSelectedClients.add(client);
                      }
                      onClientToggle(newSelectedClients);
                    }
                  }}
                  onMouseDown={(e) => e.stopPropagation()}
                >
                  <span className="main-project">{client.client_name} </span>
                  {client.projects.length > 0 && (
                    <span className={`arrow ${selectedClients.has(client) ? "open" : ""}`}>
                      <span className="main-project-title">
                        {client.projects.length} Projects
                      </span>
                      {selectedClients.has(client) ? (
                        <img src={TopArrow} alt="Open" />
                      ) : (
                        <img src={DownArrow} alt="Close" />
                      )}
                    </span>
                  )}
                </div>
                {selectedClients.has(client) && (
                  <div className="project-name1-outer">
                    {client.projects.length === 0 ? (
                      <div>No projects under this client</div>
                    ) : (
                      client.projects
                        .filter((project) =>
                          project.project_name.toLowerCase().includes(filter.toLowerCase())
                        )
                        .sort((a, b) => a.project_name.localeCompare(b.project_name))
                        .map((project) => (
                          <div key={project._id}>
                            <div
                              className={`project-name1 ${selectedProject === project ? "selected" : ""}`}
                              onMouseDown={(e) => e.stopPropagation()}
                            >
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  onProjectSelect(project, client);
                                }}
                                onMouseDown={(e) => e.stopPropagation()}
                              >
                                <span className="project-dd-title">{project.project_name} </span>
                              </div>
                              <div>
                                {project.sprints.length > 0 && (
                                  <span
                                    className={`arrow ${selectedProject === project ? "open" : ""}`}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      onProjectToggle(project);
                                    }}
                                    onMouseDown={(e) => e.stopPropagation()}
                                  >
                                    <span className="main-project-title">
                                      {project.sprints.length} Sprints
                                    </span>
                                    {selectedProject === project ? (
                                      <img src={TopArrow} alt="Open" />
                                    ) : (
                                      <img src={DownArrow} alt="Close" />
                                    )}
                                  </span>
                                )}
                              </div>
                            </div>
                            {selectedProject === project && (
                              <div onMouseDown={(e) => e.stopPropagation()}>
                                {project.sprints.length === 0 ? (
                                  <div>No sprints under this project</div>
                                ) : (
                                  <ul className="sprint-list" onMouseDown={(e) => e.stopPropagation()}>
                                    {project.sprints
                                      .sort((a, b) => a.sprint_name.localeCompare(b.sprint_name))
                                      .map((sprint) => (
                                        <li
                                          key={sprint._id}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            onSprintSelect(sprint, project, client);
                                          }}
                                          onMouseDown={(e) => e.stopPropagation()}
                                        >
                                          {sprint.sprint_name}
                                        </li>
                                      ))}
                                  </ul>
                                )}
                              </div>
                            )}
                          </div>
                        ))
                    )}
                  </div>
                )}
              </div>
            ))}
          </ul>
        </div>
      )}
    </>
  );
};

export default ProjectDropdown;
